module.exports = __webpack_public_path__ + "img/main_hsgeoje.39d93c7d.jpg";